// English for the new admin home + Rapports (2026-10-21). French string = key.
const m: Record<string, string> = {
  // Navigation
  'Rapports': 'Reports',
  // Block 1 — À faire maintenant
  'À faire maintenant': 'To do now',
  'À moi': 'Mine',
  ' + libres': ' + unassigned',
  'Tout voir': 'Show all',
  "Valider l'album": 'Approve the album',
  'Répondre': 'Reply',
  "Envoyer l'aperçu": 'Send the preview',
  'Expédier': 'Ship',
  "Ouvrir l'album": 'Open the album',
  'Ouvrir le chat': 'Open the chat',
  "Voir l'aperçu": 'See the preview',
  'Créer le colis': 'Create the parcel',
  '{n} photos reçues': '{n} photos received',
  'modification demandée': 'changes requested',
  'Rien en attente': 'Nothing waiting',
  'Voir tout ({n})': 'Show all ({n})',
  '{n} albums attendent depuis plus de 14 jours': '{n} albums have been waiting more than 14 days',
  'Voir les anciens': 'See the old ones',
  'Liste indisponible — réessayez dans un instant.': 'List unavailable — try again in a moment.',
  // Block 2 — Argent
  'Argent': 'Money',
  '{n} j vs {n} j d’avant': '{n} d vs the {n} d before',
  'Encaissé auj.': 'Collected today',
  'aucun colis livré encore': 'no parcel delivered yet',
  'Acomptes auj.': 'Deposits today',
  '{x} sur la période': '{x} over the period',
  '{x} sur {n} j': '{x} over {n} d',
  'Reste à encaisser': 'Still to collect',
  '{n} commandes en cours': '{n} orders in progress',
  '+{x} en attente de photos': '+{x} waiting for photos',
  'Commandes payées': 'Paid orders',
  'livrées, encaissées': 'delivered, collected',
  'Coût des albums': 'Album cost',
  'fabrication {a} + livraison {b}': 'production {a} + delivery {b}',
  'incomplet : {n} sans coût': 'incomplete: {n} without a cost',
  'Commandes livrées sans coût enregistré': 'Delivered orders with no recorded cost',
  '{x} / commande': '{x} / order',
  'Coût pub': 'Ad cost',
  'données manquantes': 'missing data',
  'Profit net': 'Net profit',
  '{x} avant pub': '{x} before ads',
  'commissions {x}': 'commissions {x}',
  'charges : aucune saisie': 'expenses: none entered',
  'charges {x}': 'expenses {x}',
  'Par commande': 'Per order',
  'Vente': 'Sale',
  'profit': 'profit',
  'Rentabilité': 'Profitability',
  'Profit = encaissé − coût des albums − commissions − pub − charges · Rentabilité = profit ÷ encaissé. Même formule partout.':
    'Profit = collected − album cost − commissions − ads − expenses · Profitability = profit ÷ collected. Same formula everywhere.',
  '{n} commandes sans activité exclues': '{n} inactive orders left out',
  'Chiffres indisponibles — aucun chiffre plutôt qu’un chiffre faux.': 'Figures unavailable — no figure rather than a wrong one.',
  'Mis en pause automatiquement': 'Paused automatically',
  '{n} appels en 5 min ({f} en erreur)': '{n} calls in 5 min ({f} failed)',
  'Reprendre': 'Resume',
  // Block 3 — Pipeline
  'cliquez une étape pour voir les commandes': 'click a step to see the orders',
  'Photos reçues': 'Photos received',
  'Album fait': 'Album made',
  'Validé': 'Approved',
  'Impression': 'Printing',
  'Expédié': 'Shipped',
  'Livré': 'Delivered',
  'en cours': 'in progress',
  'en attente de validation': 'awaiting approval',
  'prêt à imprimer': 'ready to print',
  "chez l'imprimeur": 'at the printer',
  'chez AMEEX': 'with AMEEX',
  'cette période': 'this period',
  '{n} commandes dans cette étape depuis plus de 48 h': '{n} orders in this step for more than 48 h',
  'Les commandes plus vieilles que 14 jours sans activité sont comptées à part': 'Orders with no activity for 14 days are counted apart',
  'Rapports → Dossiers anciens': 'Reports → Old files',
  // Rapports
  'Le détail qui a quitté l’accueil — même période pour tout': 'The detail that left the home page — one period for everything',
  'Dossiers anciens': 'Old files',
  'Aucun dossier sans activité depuis 14 jours.': 'No order without activity for 14 days.',
  '{n} commandes sans activité depuis plus de 14 jours': '{n} orders with no activity for more than 14 days',
  '{n} j': '{n} d',
  'Colis en route et perdus': 'Parcels in transit and lost',
  'trop tôt pour un taux': 'too early for a rate',
  '{n} colis — trop tôt': '{n} parcels — too early',
  'Pas de taux sous {n} colis terminés': 'No rate under {n} finished parcels',
  'trop tôt': 'too early',
  '{n} colis livrés seulement': 'only {n} parcels delivered',
  'À suivre': 'To follow up',
  'Idées de couvertures demandées': 'Cover ideas clients asked for',
  'Équipe et assistant': 'Team and assistant',
  'Commandes confirmées': 'Confirmed orders',
  // Rentabilité card
  'Coût par album': 'Cost per album',
  'Coût par commande': 'Cost per order',
  'Commissions agents': 'Agent commissions',
  '{n} commandes confirmées': '{n} confirmed orders',
  '{s} de pub ÷ {n} albums': '{s} of ads ÷ {n} albums',
  '{p} de marge − {s} de pub − {c} de commissions − {e} de charges': '{p} margin − {s} ads − {c} commissions − {e} expenses',
  'données pub manquantes': 'ad data missing',
  'données pub manquantes (dernière synchro {d}) — {x} avant pub': 'ad data missing (last sync {d}) — {x} before ads',
  'Notoriété exclue': 'Awareness excluded',
  'Données publicitaires indisponibles': 'Ad data unavailable',
  'Aucun chiffre affiché plutôt qu’un chiffre faux. Réessayez plus tard.': 'No figure rather than a wrong one. Try again later.',
  'La pub dépensée aujourd’hui produit des commandes livrées plus tard — sur une courte période le profit paraît plus bas qu’il ne l’est.':
    'Ads spent today bring orders delivered later — over a short period profit looks lower than it is.',
  // v2 cockpit (2026-10-22)
  "mis à jour à l'instant": 'updated just now',
  'mis à jour il y a {n} min': 'updated {n} min ago',
  'mis à jour il y a {n} h': 'updated {n} h ago',
  'Période': 'Period',
  'Mois': 'Month',
  'Traiter': 'Handle',
  'Détail': 'Details',
  '1 client attend > 1 h': '1 client waiting > 1 h',
  '{n} clients attendent > 1 h': '{n} clients waiting > 1 h',
  'Profit négatif : {x} DH': 'Negative profit: {x} DH',
  'encaissé {r} DH · pub {a} DH': 'collected {r} DH · ads {a} DH',
  'Coût pub : synchro en panne': 'Ad cost: sync is down',
  'dernière synchro {d} · profit net inconnu': 'last sync {d} · net profit unknown',
  'Commandes −{x} % sur la période': 'Orders −{x} % this period',
  'Commandes +{x} % sur la période': 'Orders +{x} % this period',
  '{c} nouvelles vs {p}': '{c} new vs {p}',
  '{n} colis bloqués': '{n} parcels stuck',
  '{who} sans mouvement AMEEX': '{who} no AMEEX movement',
  '{n} albums en attente > 48 h': '{n} albums waiting > 48 h',
  'Rentable : {x} DH de profit': 'Profitable: {x} DH profit',
  'après pub, fabrication et livraison': 'after ads, production and delivery',
  'Commandes stables': 'Orders steady',
  'personne n’attend de réponse': 'nobody is waiting for an answer',
  'Production à l’heure': 'Production on time',
  'aucun album en attente > 48 h': 'no album waiting > 48 h',
  'Livraisons fluides': 'Deliveries flowing',
  'aucun colis bloqué chez AMEEX': 'no parcel stuck at AMEEX',
  'Tout va bien': 'All good',
  'rien à signaler': 'nothing to report',
  'Pub / commande': 'Ads / order',
  '1 colis livré': '1 parcel delivered',
  '{x} DH avant pub': '{x} DH before ads',
  "{n} % de l'encaissé": '{n} % of collected',
  'nouvelles · {n} {prev}': 'new · {n} {prev}',
  'nouvelles': 'new',
  'la veille': 'the day before',
  "la sem. d'avant": 'the week before',
  "les 30 j d'avant": 'the 30 d before',
  "la période d'avant": 'the period before',
  'aucun colis livré': 'no parcel delivered',
  'profit moyen {x} DH / commande': 'average profit {x} DH / order',
  'profit moyen': 'average profit',
  '{x} DH de pub · aucune commande': '{x} DH of ads · no order',
  '{x} DH de pub · ×{y} rapporté': '{x} DH of ads · ×{y} returned',
  '{x} DH de pub · {n} {unit}': '{x} DH of ads · {n} {unit}',
  'Pub par': 'Ads per',
  'Tous les appels': 'All calls', 'Fonction': 'Feature', 'Toutes les fonctions': 'All features',
  'Commande, ex. #1256': 'Order, e.g. #1256', 'Échecs seulement': 'Failures only',
  'Liste indisponible. Réessayez.': 'List unavailable. Try again.', 'Commande introuvable.': 'Order not found.',
  'Aucun appel avec ces filtres sur la période.': 'No call with these filters in the period.',
  'Heure': 'Time', 'Commande / chat': 'Order / chat', 'Modèle': 'Model', 'Jetons': 'Tokens', 'Durée': 'Duration', 'Coût': 'Cost',
  'échec': 'failed', 'clé « finder »': '« finder » key', 'prix pas encore reçu d’OpenRouter': 'price not yet received from OpenRouter',
  'en attente': 'pending', 'Voir plus': 'Show more',
  'Confirmation': 'Confirmation', 'Site': 'Web', 'WA': 'WA',
  'Confirmées : {a}/{b} leads · Site {c}/{d} · WhatsApp {e}/{f}': 'Confirmed: {a}/{b} leads · Website {c}/{d} · WhatsApp {e}/{f}',
  'Site : {a}/{b} leads · WhatsApp : {c}/{d} leads': 'Website: {a}/{b} leads · WhatsApp: {c}/{d} leads',
  '{n}/{m} leads confirmés': '{n}/{m} leads confirmed',
  'Taux de confirmation par jour — 14 derniers jours': 'Confirmation rate per day — last 14 days',
  'Lead': 'Lead', 'Cmd': 'Order', 'Conf.': 'Conf.', 'Livr.': 'Deliv.',
  'Pub / lead': 'Ads / lead', 'Pub / confirmée': 'Ads / confirmed', 'Pub / livrée': 'Ads / delivered',
  'leads': 'leads', 'commandes': 'orders', 'confirmées': 'confirmed', 'livrées': 'delivered',
  'Dépense pub par jour — 14 derniers jours': 'Ad spend per day — last 14 days',
  '{x} DH de pub': '{x} DH of ads',
  'Taux de livraison réussie (livrés ÷ livrés + retours)': 'Delivery success rate (delivered ÷ delivered + returns)',
  'jours': 'days',
  '{n} retour': '{n} return',
  '{n} retours': '{n} returns',
  '14 derniers jours, un point par jour (quelle que soit la période)': 'Last 14 days, one point a day (whatever the period)',
  'Ventes vs pub': 'Sales vs ads',
  'Pub': 'Ads',
  'pub': 'ads',
  '14 jours : {r} DH encaissés, {a} DH de pub': '14 days: {r} DH collected, {a} DH of ads',
  'Caisse du jour': "Today's cash",
  'À encaisser': 'To collect',
  '{n} cmd': '{n} orders',
  '+{x} en photos': '+{x} waiting for photos',
  '{n} commandes sans activité depuis 30 jours exclues': '{n} orders with no activity for 30 days left out',
  'Production': 'Production',
  'auj.': 'today',
  '7 j': '7 d',
  '30 j': '30 d',
  'mois': 'month',
  '{n} bloquées': '{n} stuck',
  '+{n} sans activité depuis 14 jours (Rapports → Dossiers anciens)': '+{n} with no activity for 14 days (Reports → Old files)',
  'À moi + libres': 'Mine + unassigned',
};
export default m;
